import React from 'react';
import { Pressable, StyleSheet, Text, type PressableStateCallbackType } from 'react-native';
import { Feather } from '@expo/vector-icons';
import { Paprika } from '../../styles/theme';

interface Props {
  label: string;
  selected: boolean;
  onPress: () => void;
  testID: string;
}

/** A toggle chip on the safety screen; a shield appears when selected. */
export function AllergenChip({ label, selected, onPress, testID }: Props) {
  return (
    <Pressable
      onPress={onPress}
      testID={testID}
      accessibilityRole="checkbox"
      accessibilityState={{ checked: selected }}
      style={({ hovered }: PressableStateCallbackType & { hovered?: boolean }) => [styles.chip, hovered && styles.chipHover, selected && styles.chipOn]}
    >
      {selected && <Feather name="shield" size={12} color={Paprika.accent} />}
      <Text style={[styles.label, selected && styles.labelOn]}>{label}</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  chip: {
    flexDirection: 'row', alignItems: 'center', gap: 6,
    paddingVertical: 9, paddingHorizontal: 14, borderRadius: 999,
    backgroundColor: Paprika.cardBg, borderWidth: 1, borderColor: Paprika.hairline,
  },
  chipHover: { borderColor: Paprika.brandSoft },
  chipOn: { backgroundColor: Paprika.brandTint, borderColor: Paprika.brandSoft },
  label: { fontFamily: 'Inter-Medium', fontSize: 13, color: Paprika.textPrimary },
  labelOn: { color: Paprika.accent, fontFamily: 'Inter-SemiBold' },
});
